import { createRouter, createWebHashHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';

//Import navigationGuards
import logoutGuard from './logoutGuard';
import authGuard from './authGuard';
import homeGuard from './homeGuard';
import loginGuard from './loginGuard';

const View = (view: string) => () => import(`@/views/${view}`);

//Pre define the routes here, all possible routes should be in here, menuItems will decide what page will be accessible for what user 
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: View('LoginPage.vue'),
    beforeEnter: homeGuard
  },
  {
    path: '/scan/:position/:station',
    name: 'ScanWithStation',
    component: View('ScanPage.vue'),
    beforeEnter: authGuard,
    meta: { 
      noSwipeMenu: true
    }
  },
  {
    path: '/scan/:position/:station/:bool',
    name: 'ScanWithStationBool',
    component: View('ScanPage.vue'),
    beforeEnter: authGuard,
    meta: { 
      noSwipeMenu: true
    }
  },
  {
    path: '/scan/:position',
    name: 'Scan',
    component: View('ScanPage.vue'),
    beforeEnter: authGuard,
    meta: { 
      noSwipeMenu: true
    }
  },
  {
    path: '/mijnwasgoed',
    alias: ['/mylaundry'],
    name: 'MyLaundry',
    component: View('MyLaundryPage.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/mijnkledingkast',
    alias: ['/mywardrobe'],
    name: 'MyWardrobe',
    component: View('MyWardrobePage.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/waarismijnwas',
    name: 'MyLaundryWhere',
    component: View('MyLaundryWherePage.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/transport/:route?',
    name: 'TransportPage',
    component: View('TransportPage.vue'),
    beforeEnter: authGuard,
  },
  {
    path: '/transport/details/:route/:cardId',
    name: 'TransportCardDetailsPage',
    component: View('TransportCardDetailsPage.vue'),
    beforeEnter: authGuard,
  },
  {
    path: '/planbord/:board?/:week?',
    name: 'PlanningboardPage',
    component: View('PlanningboardPage.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/planbordkaartje/:board/:week:/:cardId',
    name: 'PlanningboardCardPage',
    component: View('PlanningboardCardDetailsPage.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/volgendeBezorging',
    name: 'NextDeliveryPage',
    component: View('NextDeliveryPage.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/contact',
    alias: ['/dashboard'],
    name: 'Contact',
    component: View('ContactPage.vue'),
    beforeEnter: authGuard,
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: View('FAQPage.vue'),
    beforeEnter: authGuard,
  },
  {
    path: '/uitlevernormen',
    alias: ['/routeregels'],
    name: 'DeliveryNormsPage',
    component: View('DeliveryNormsPage.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/uitlevernormen/:route/:customer/:department/:customername',
    name: 'DeliveryNormsEditPage',
    component: View('DeliveryNormsEditPage.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/voorraad',
    name: 'VoorraadKlantPage',
    component: View('VoorraadKlantenPage.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/voorraadbestellen',
    name: 'VoorraadBestellenKlantPage',
    component: View('VoorraadKlantenPage.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/voorraad/:klant',
    name: 'VoorraadArtikelPage',
    component: View('VoorraadArtikelenPage.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/voorraadbestellen/:klant',
    name: 'VoorraadBestellenArtikelPage',
    component: View('VoorraadArtikelenPage.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/voorraad/:klant/:artikel',
    name: 'VoorraadPage',
    component: View('VoorraadPage.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/voorraadbestellen/:klant/:artikel',
    name: 'VoorraadBestellenPage',
    component: View('VoorraadPage.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/facturen',
    name: 'FacturenPage',
    component: View('FacturenPage.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/doeeenmelding',
    name: 'DoeEenMelding',
    component: View('DoeEenMelding.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/rapport',
    name: 'ReportsPage',
    component: View('ReportOverview.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/embed/:id',
    name: 'EmbedPage',
    component: View('EmbedPage.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/content/:id',
    name: 'ContentPage',
    component: View('ContentPage.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/homeIcons',
    name: 'HomeIconsPage',
    component: View('HomeIconsPage.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/gebruikergegevens',
    name: 'GebruikerGegevensPage',
    component: View('GebruikerGegevens.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/digitalegarderobe',
    name: 'DigitaleGarderobePage',
    component: View('DigitaleGarderobePage.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/klantenservice',
    name: 'KlantenservicePage',
    component: View('ContactKlantenService.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/login',
    name: 'Login',
    component: View('LoginPage.vue'),
    beforeEnter: loginGuard,
    meta: { 
      noSwipeMenu: true
    }
  },
  {
    path: '/logout',
    name: 'Logout',
    component: View('LoginPage'),
    beforeEnter: logoutGuard
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
